var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { generateGuestLink } from '@lucidlink/sdk';
import { translate, useToastService } from '@lucidlink/uicore';
import { DEPENDENCY_KEYS, useDependency } from '#context';
import { useCopyToClipboardWithToast } from '#hooks';
export const useCopyGuestLink = (guestLinkId, linkSecret) => {
    _react_refresh_temp_1();
    const webClientUrl = useDependency(DEPENDENCY_KEYS.CLIENT_BASE_URL);
    const { addToast } = useToastService();
    const { copyToClipboard } = useCopyToClipboardWithToast();
    const mutation = useMutation({
        mutationFn: async () => {
            if (!linkSecret) {
                addToast({
                    content: {
                        message: translate('Unable to copy link to clipboard. Please try again.'),
                    },
                    kind: 'negative',
                    hasCloseButton: true,
                    'data-testid': 'error-copy-guest-link',
                });
                return;
            }
            const guestLink = generateGuestLink(new URL(webClientUrl), guestLinkId, linkSecret).toString();
            await copyToClipboard(guestLink, {
                onSuccess: () => {
                    addToast({
                        content: {
                            message: translate('Link was copied to clipboard.'),
                        },
                        kind: 'positive',
                        hasCloseButton: true,
                        'data-testid': 'success-copy-guest-link',
                    });
                },
            });
        },
    });
    return mutation;
};
_react_refresh_temp_1(useCopyGuestLink, "IzFC++acfwOdoQIeOEZtFhq7mz0=", false, () => [useDependency, useToastService, useCopyToClipboardWithToast, useMutation]);
